export default {
  en: {
    advancedAnalyticsPage: {
      loading: "Loading analytics...",
      title: "Advanced Analytics",
      subtitle: "Comprehensive election data insights",
      timeRange: "Time Range",
      last24h: "Last 24h",
      last7d: "Last 7 days",
      last30d: "Last 30 days",
      allTime: "All time",
      refresh: "Refresh",
      export: "Export",
      totalSubmissions: "Total Submissions",
      pendingQueue: "Pending Queue",
      approvalRate: "Approval Rate",
      certificationRate: "Certification Rate",
      correctionRate: "Correction Rate",
      avgProcessing: "Avg Processing",
      hoursShort: "{{value}} hrs",
      tabOverview: "Overview",
      tabVerification: "Verification",
      tabRegional: "Regional",
      tabTrends: "Trends",
      statusDistribution: "Status Distribution",
      verificationByType: "Verification by Election Type",
      pending: "Pending",
      approved: "Approved",
      certified: "Certified",
      rejected: "Rejected",
      correction: "Correction",
      correctionPending: "Correction Pending",
      council: "Council",
      senatorial: "Senatorial",
      other: "Other",
      resultsApproved: "Results Approved",
      resultsCertified: "Results Certified",
      awaitingReview: "Awaiting Review",
      electionsTitle: "{{type}} Elections",
      regionalPerformance: "Regional Performance",
      regionalDesc: "Submission and verification rates by region",
      submissions: "Submissions",
      coverage: "Coverage %",
      noRegional: "No regional data available",
      submissionTrends: "Submission Trends",
      trendsDesc: "Results submitted over time (hourly)",
      totalVotes: "Total Votes",
      noTrends: "No trend data available"
    }
  },
  fr: {
    advancedAnalyticsPage: {
      loading: "Chargement des analyses...",
      title: "Analyses avancées",
      subtitle: "Aperçu complet des données électorales",
      timeRange: "Période",
      last24h: "Dernières 24 h",
      last7d: "7 derniers jours",
      last30d: "30 derniers jours",
      allTime: "Toute la période",
      refresh: "Actualiser",
      export: "Exporter",
      totalSubmissions: "Total des soumissions",
      pendingQueue: "File d'attente",
      approvalRate: "Taux d'approbation",
      certificationRate: "Taux de certification",
      correctionRate: "Taux de correction",
      avgProcessing: "Traitement moyen",
      hoursShort: "{{value}} h",
      tabOverview: "Aperçu",
      tabVerification: "Vérification",
      tabRegional: "Régional",
      tabTrends: "Tendances",
      statusDistribution: "Répartition par statut",
      verificationByType: "Vérification par type d'élection",
      pending: "En attente",
      approved: "Approuvé",
      certified: "Certifié",
      rejected: "Rejeté",
      correction: "Correction",
      correctionPending: "Correction en attente",
      council: "Municipales",
      senatorial: "Sénatoriales",
      other: "Autres",
      resultsApproved: "Résultats approuvés",
      resultsCertified: "Résultats certifiés",
      awaitingReview: "En attente de révision",
      electionsTitle: "Élections {{type}}",
      regionalPerformance: "Performance régionale",
      regionalDesc: "Taux de soumission et de vérification par région",
      submissions: "Soumissions",
      coverage: "Couverture %",
      noRegional: "Aucune donnée régionale disponible",
      submissionTrends: "Tendances des soumissions",
      trendsDesc: "Résultats soumis au fil du temps (par heure)",
      totalVotes: "Total des votes",
      noTrends: "Aucune donnée de tendance disponible"
    }
  }
};
